import "./editorialForms.css";

const categories = [
  { id: "car", name: "Carro" },
  { id: "motorcycle", name: "Moto" },
  { id: "bicycle", name: "Bicicleta" },
  { id: "house", name: "Casa" },
  { id: "apartment", name: "Apartamento" },
  { id: "equipment", name: "Equipamento" },
  { id: "tools", name: "Ferramentas" },
  { id: "electronics", name: "Eletrônicos" },
  { id: "party", name: "Festas" },
  { id: "other", name: "Outros" },
];

const conditions = [
  { id: "new", name: "Novo" },
  { id: "like_new", name: "Seminovo" },
  { id: "good", name: "Bom estado" },
  { id: "fair", name: "Estado regular" },
];

const availabilityOptions = [
  { id: "available", name: "Disponível" },
  { id: "rented", name: "Alugado" },
  { id: "maintenance", name: "Em manutenção" },
];

export default function RentalForm({ data, onChange }) {
  return (
    <div className="editorial_form rental_form">
      <div className="editorial_form_section">
        <label>
          Nome do Item <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Honda Civic 2022, Furadeira Bosch..."
          value={data?.itemName || ""}
          onChange={(e) => onChange({ ...data, itemName: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descrição</label>
        <textarea
          placeholder="Detalhes do item, especificações, o que está incluso..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={1000}
          rows={3}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Categoria</label>
          <select
            value={data?.category || ""}
            onChange={(e) => onChange({ ...data, category: e.target.value })}
          >
            <option value="">Selecione</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Condição</label>
          <select
            value={data?.condition || ""}
            onChange={(e) => onChange({ ...data, condition: e.target.value })}
          >
            <option value="">Selecione</option>
            {conditions.map((cond) => (
              <option key={cond.id} value={cond.id}>
                {cond.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Preço por Dia (R$)</label>
          <input
            type="number"
            placeholder="0.00"
            value={data?.pricePerDay || ""}
            onChange={(e) =>
              onChange({ ...data, pricePerDay: parseFloat(e.target.value) || 0 })
            }
            min="0"
            step="0.01"
          />
        </div>

        <div className="editorial_form_section">
          <label>Preço por Semana (R$)</label>
          <input
            type="number"
            placeholder="0.00"
            value={data?.pricePerWeek || ""}
            onChange={(e) =>
              onChange({ ...data, pricePerWeek: parseFloat(e.target.value) || 0 })
            }
            min="0"
            step="0.01"
          />
        </div>

        <div className="editorial_form_section">
          <label>Preço por Mês (R$)</label>
          <input
            type="number"
            placeholder="0.00"
            value={data?.pricePerMonth || ""}
            onChange={(e) =>
              onChange({ ...data, pricePerMonth: parseFloat(e.target.value) || 0 })
            }
            min="0"
            step="0.01"
          />
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Caução (R$)</label>
          <input
            type="number"
            placeholder="0.00"
            value={data?.deposit || ""}
            onChange={(e) =>
              onChange({ ...data, deposit: parseFloat(e.target.value) || 0 })
            }
            min="0"
            step="0.01"
          />
        </div>

        <div className="editorial_form_section">
          <label>Disponibilidade</label>
          <select
            value={data?.availability || "available"}
            onChange={(e) => onChange({ ...data, availability: e.target.value })}
          >
            {availabilityOptions.map((opt) => (
              <option key={opt.id} value={opt.id}>
                {opt.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Localização</label>
        <input
          type="text"
          placeholder="Cidade, Bairro"
          value={data?.location || ""}
          onChange={(e) => onChange({ ...data, location: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Entrega</label>
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="deliveryAvailable"
            checked={data?.deliveryAvailable || false}
            onChange={(e) =>
              onChange({ ...data, deliveryAvailable: e.target.checked })
            }
          />
          <label htmlFor="deliveryAvailable">Entrega disponível</label>
        </div>
        {data?.deliveryAvailable && (
          <input
            type="number"
            placeholder="Taxa de entrega (R$)"
            value={data?.deliveryFee || ""}
            onChange={(e) =>
              onChange({ ...data, deliveryFee: parseFloat(e.target.value) || 0 })
            }
            min="0"
            step="0.01"
            style={{ marginTop: "8px" }}
          />
        )}
      </div>

      <div className="editorial_form_section">
        <label>Termos do Aluguel</label>
        <textarea
          placeholder="Condições, regras, documentos necessários..."
          value={data?.rentalTerms || ""}
          onChange={(e) => onChange({ ...data, rentalTerms: e.target.value })}
          rows={2}
        />
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
        </svg>
        <span>
          Adicione fotos claras do item para aumentar a confiança dos interessados.
        </span>
      </div>
    </div>
  );
}
